<template>
	<el-dialog append-to-body v-dialogDrag :close-on-click-modal="false" :title="$t('updatePassword')"
		:visible.sync="visible" width="600px">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataSub()" label-width="140px">
			<el-form-item :label="$t('name')">
				<span>{{ userName }}</span>
			</el-form-item>
			<el-form-item :label="$t('oldPwd')" prop="password">
				<el-input show-password type="password" :placeholder="$t('placeholder')+$t('oldPwd')"
					v-model="dataForm.password"></el-input>
			</el-form-item>
			<el-form-item :label="$t('Pwd')" prop="newPassword">
				<el-input show-password type="password" :placeholder="$t('placeholder')+$t('Pwd')"
					v-model="dataForm.newPassword"></el-input>
			</el-form-item>
			<el-form-item :label="$t('twoPwd')" prop="confirmPassword">
				<el-input show-password type="password" :placeholder="$t('placeholder')+$t('twoPwd')"
					v-model="dataForm.confirmPassword"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button v-noMoreClick @click="visible = false">{{$t('cancel')}}</el-button>
			<el-button v-noMoreClick type="primary" @click="dataSub()">{{$t('submit')}}</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		clearLoginInfo
	} from '@/utils'
	export default {
		data() {
			return {
				visible: false,
				dataForm: {
					password: '',
					newPassword: '',
					confirmPassword: ''
				},
				dataRule: {}
			}
		},
		computed: {
			userName: {
				get() {
					return this.$store.state.user.name;
				},
			},
		},
		methods: {
			// 初始化
			init() {
				this.visible = true
				this.dataRule = {
					password: [{
						required: true,
						message: this.$t('placeholder') + this.$t('oldPwd'),
						trigger: 'blur'
					}],
					newPassword: [{
						required: true,
						message: this.$t('placeholder') + this.$t('Pwd'),
						trigger: 'blur'
					}],
					confirmPassword: [{
							required: true,
							message: this.$t('placeholder') + this.$t('twoPwd'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (this.dataForm.newPassword !== value) {
									callback(new Error(this.$t('okPwd')))
								} else {
									callback()
								}
							},
							trigger: 'blur'
						}
					]
				}
				this.$nextTick(() => {
					this.$refs['dataForm'].resetFields()
				})
			},
			// 表单提交
			dataSub() {
				this.$refs['dataForm'].validate((valid) => {
					if (valid) {
						this.$http({
							url: this.$http.adornUrl('/sys/user/password'),
							method: 'post',
							data: this.$http.adornData({
								'password': this.dataForm.password,
								'newPassword': this.dataForm.newPassword
							})
						}).then(({
							data
						}) => {
							if (data && data.code == 0) {
								this.$message({
									message: '操作成功',
									type: 'success',
									duration: 1500,
									onClose: () => {
										this.visible = false
										this.$nextTick(() => {
											clearLoginInfo()
											this.$router.replace({
												name: 'login'
											})
										})
									}
								})
							} else {
								this.$message.error(data.msg)
							}
						})
					}
				})
			}
		}
	}
</script>